module.exports = __webpack_public_path__ + "img/pp_logo2.eb398a30.jpg";